import { ComplaintRequestPayload, ComplaintResponse } from './types';
import { ApiEndpoints } from '@shared/api/api-endpoints';
import { consumerApiClient } from '@shared/api/clients/apiClientFactory';

export const complaintApis = {
    createBulkComplaintRequest: async (data: any): Promise<any> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "cx",
        `bulk-complaint-request/v1`
      );
      const response = await consumerApiClient.post(url, data);
      return response.data;
    },

    createSingleComplaintRequest: async (data: any): Promise<any> => {
      const url = ApiEndpoints.createUrlWithPathVariables(
        "consumerWeb",
        `complaints`
      );
      const response = await consumerApiClient.post(url, data);
      return response.data;
    }
};
